(function () {
  'use strict';

  var MIN_QUERY_LENGTH = 2;
  var DEBOUNCE_MS = 220;

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeSearchUrl(form, query) {
    var action = form.getAttribute('action') || '/search';
    var url = new URL(action, window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');
    return url.toString();
  }

  function productImage(product) {
    if (product && product.image) return product.image;
    if (product && product.featured_image && product.featured_image.url) return product.featured_image.url;
    if (product && product.featured_image) return product.featured_image;
    return '';
  }

  function productPrice(product) {
    if (!product) return '';
    var raw = product.price || product.price_min;
    if (!raw && product.variants && product.variants.length) raw = product.variants[0].price;
    var amount = Number(raw);
    /* suggest.json renvoie « 48.90 » : même format que les prix de la boutique. */
    return raw && isFinite(amount) ? '€' + amount.toFixed(2).replace('.', ',') : '';
  }

  function renderResults(root, data, query) {
    var result = qs('.search-bar__result', root);
    var content = qs('.search-bar__result-content', root);
    var empty = qs('.search-bar__empty', root);
    if (!result || !content) return;

    var products = (((data || {}).resources || {}).results || {}).products || [];
    var pages = (((data || {}).resources || {}).results || {}).pages || [];
    var articles = (((data || {}).resources || {}).results || {}).articles || [];
    var items = products.concat(pages).concat(articles).slice(0, 8);

    result.classList.remove('hide');
    result.classList.remove('loading');
    if (empty) empty.classList.add('hide');

    if (!items.length) {
      content.innerHTML =
        '<div class="viva-search-suggest__empty">' +
        '<p>Aucun résultat rapide.</p>' +
        '<a href="/search?q=' +
        encodeURIComponent(query) +
        '&type=product&options%5Bprefix%5D=last">Voir la recherche complète</a>' +
        '</div>';
      return;
    }

    content.innerHTML = items
      .map(function (item) {
        var isProduct = item.type === 'product' || item.object_type === 'product' || productImage(item);
        var title = escapeHtml(item.title || item.name || '');
        var url = item.url || item.handle || '#';
        var image = productImage(item);
        var price = productPrice(item);
        if (url && url.charAt(0) !== '/' && url.indexOf('http') !== 0) url = '/products/' + url;

        return (
          '<a class="viva-search-suggest__item" href="' +
          escapeHtml(url) +
          '">' +
          '<span class="viva-search-suggest__media">' +
          (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy">' : '<span aria-hidden="true">⌕</span>') +
          '</span>' +
          '<span class="viva-search-suggest__body">' +
          '<span class="viva-search-suggest__title">' +
          title +
          '</span>' +
          (isProduct && price ? '<span class="viva-search-suggest__price">' + escapeHtml(price) + '</span>' : '') +
          '</span>' +
          '</a>'
        );
      })
      .join('');
  }

  function hideResults(root) {
    var result = qs('.search-bar__result', root);
    var content = qs('.search-bar__result-content', root);
    var empty = qs('.search-bar__empty', root);
    if (result) result.classList.add('hide');
    if (content) content.innerHTML = '';
    if (empty) empty.classList.remove('hide');
  }

  function bindSearchRoot(root) {
    if (!root || root.getAttribute('data-viva-search-bound') === 'true') return;
    var form =
      root.matches && root.matches('form')
        ? root
        : qs('form[role="search"], form', root);
    var input = qs('input[type="search"][name="q"], input[name="q"]', root);
    if (!form || !input) return;

    root.setAttribute('data-viva-search-bound', 'true');

    form.addEventListener('submit', function (event) {
      var query = (input.value || '').trim();
      if (!query) {
        event.preventDefault();
        input.focus();
        return;
      }
      event.preventDefault();
      window.location.href = normalizeSearchUrl(form, query);
    });

    if (root.getAttribute('data-completion') !== 'true') return;

    var timer = null;
    var controller = null;
    /* En capture sur root : l’autocomplétion de theme.js ne doit pas traiter la frappe en parallèle. */
    root.addEventListener('input', function (event) {
      if (event.target !== input) return;
      event.stopPropagation();
      var query = (input.value || '').trim();
      window.clearTimeout(timer);
      if (controller) controller.abort();

      if (query.length < MIN_QUERY_LENGTH) {
        hideResults(root);
        return;
      }

      timer = window.setTimeout(function () {
        controller = new AbortController();
        var suggestUrl =
          '/search/suggest.json?q=' +
          encodeURIComponent(query) +
          '&resources[type]=product,page,article&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor';

        var result = qs('.search-bar__result', root);
        if (result) {
          result.classList.remove('hide');
          result.classList.add('loading');
        }

        fetch(suggestUrl, {
          headers: { Accept: 'application/json' },
          signal: controller.signal
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Search suggest failed');
            return response.json();
          })
          .then(function (data) {
            if ((input.value || '').trim() !== query) return;
            renderResults(root, data, query);
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            hideResults(root);
          });
      }, DEBOUNCE_MS);
    }, true);
  }

  function init() {
    qsa('search-bar').forEach(bindSearchRoot);
    qsa('form[role="search"]').forEach(function (form) {
      if (form.closest('search-bar')) return;
      bindSearchRoot(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
